module.exports = __webpack_public_path__ + "img/cover.e33b938f.png";